module.exports = __webpack_public_path__ + "static/img/loader.56f2a72.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loader.gif
// module id = 671
// module chunks = 1